import { render, staticRenderFns } from "./settingsApplication.vue?vue&type=template&id=0af68498&"
import script from "./settingsApplication.vue?vue&type=script&lang=js&"
export * from "./settingsApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports